<template>
  <div>
    <Header/>
    <router-view />
    <Footer/>
  </div>
</template>

<script>
import emitter from '@/methods/mitt' //mitt.js
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { defineComponent, computed, reactive } from "vue"
import { useHead } from "@vueuse/head"

export default defineComponent({
  setup() {
    const siteData = reactive({
      title: `曜越單車電競爭霸戰`,
      description: `曜越單車電競爭霸戰 - 2022/10/15 曜越單車旗艦館內，盛大展開！`,
      keywords: `曜越單車電競爭霸戰, 曜越單車旗艦館, 曜越單車`,
    })

    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: "og:image",
          content: `https://file.thermaltake.com/file/others/main_logo.png`,
        },
        {
          property: "og:description",
          content: `曜越單車電競爭霸戰 - 2022/10/15 曜越單車旗艦館內，盛大展開！`,
        },
      ],
    })
  },
  methods: {
    login () {
      this.$gtag.event('login', { method: 'Google' })
    },
  },
  components: {
    Header,
    Footer,
  },
  provide() { //mitt套件
    return {
      emitter,
    }
  },
})
</script>

<style lang="scss">
@import "./assets/scss/all";
</style>
